import { Route, Routes } from '@angular/router';
import { addSpotterRoutes } from '@spotter/providers/spotter-providers';
import { addAbsencePageRoutes } from './routes/absence.routes';
import { addSightingPageRoutes } from './routes/sightings.routes';
import { addUserPageRoutes } from './routes/user.routes';
import { addDataPageRoutes } from './routes/data.routes';
import { addAdminPageRoutes } from './routes/admin.routes';
import { addToolsRoutes } from './routes/tools.routes';

/** Adds the Tools pages routes. */


/** Adds the generic information pages. */
function addStaticPageRoutes(): Route[] {
  return [
    { path: '', loadComponent: () => import('./pages/generic/home-page/home-page.component').then(m => m.HomePageComponent) },
    { path: 'about', loadComponent: () => import('./pages/generic/about-page/about-page.component').then(m => m.AboutPageComponent) },
    { path: 'learn', loadComponent: () => import('./pages/generic/learn-page/learn-page.component').then(m => m.LearnPageComponent) },
    { path: 'leaderboards', loadComponent: () => import('./pages/generic/leaderboards/leaderboards.page').then(m => m.LeaderboardsPage) },
    { path: 'threat-mapping', loadComponent: () => import('./pages/generic/threat-mapping/threat-mapping.page').then(m => m.ThreatMappingPage) },
    { path: 'identify', loadComponent: () => import('./pages/generic/identify-page/identify-page.component').then(m => m.IdentifyPageComponent) },
  ];
}


/** Adds page redirections for old paths. */
function addRedirects(): Route[] {
  return [
    { path: 'explore', redirectTo: 'sightings/grid', pathMatch: 'full' },
    { path: 'explore/grid', redirectTo: 'sightings/grid', pathMatch: 'full' },
    { path: 'map', redirectTo: 'sightings/map', pathMatch: 'full' },
    { path: 'admin', redirectTo: 'admin/dashboard', pathMatch: 'full' },
    { path: 'reports', redirectTo: 'reports/sightings', pathMatch: 'full' },
    { path: 'reports/sightings', redirectTo: 'data/reports/sightings', pathMatch: 'full' },
  ];
}


export const routes: Routes = [
  ...addStaticPageRoutes(),
  ...addRedirects(),

  ...addSightingPageRoutes(),
  ...addAbsencePageRoutes(),
  ...addToolsRoutes(),
  ...addAdminPageRoutes(),
  ...addDataPageRoutes(),
  ...addUserPageRoutes(),

  ...addSpotterRoutes(),
];